import { toast } from 'react-toastify';

export const config = {
  identityServerURL: process.env.REACT_APP_IDENTITY_SERVER_URL,
  apiEndpoint: process.env.REACT_APP_API_URL,
  logout_uri: process.env.REACT_APP_LOGOUT_URI,
  client_id: process.env.REACT_APP_CLIENT_ID
};

export const useKeycloak = process.env.REACT_APP_USE_KEYCLOAK === "TRUE";

export const sessionUsername = "mpog_portal_login_username";
export const sessionUser = "mpog_portal_login_user";
export const sessionUserPerms = "mpog_portal_login_user_perms";
export const sessionAccessToken = "mpog_portal_access_token";
export const sessionRefreshToken = "mpog_portal_refresh_token";
export const sessionIdToken = "id_token";
export const sessionActiveTime = "mpog_portal_active_time";

export const MAX_INACTIVE_TIME = 30 * 60 * 1000;

export const Empty_Logo_Path = process.env.PUBLIC_URL + "/logos/Empty_logo.png";

export const Custom_Forms = {
  addAeSaeEvent: 29,
  onSaveSae: 2,
  saeTabs: 30,
  saeForms: [24, 29, 31, 32]
};

//Toast Usage: toaster('toasterType','message', {optionalConfig1: value, optionalConfig2: value});
export function toaster(type = 'info', msg = 'Event Unknown', customConfig = {}) {
  let defaultConfig = {
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
    theme: 'colored'
  }
  toast[type.toLowerCase()](msg, JSON.stringify(customConfig) === '{}' ? defaultConfig : customConfig);
}